import constants from "../constants";

const typeMap = {
  activity: "Activity",
  tour: "Adventure Tours",
};

const buildLabel = ({
  type,
  provider,
  name,
}) => {
  const partnerClickType = typeMap[type] || type;

  if (provider.indexOf("bdc") > -1) {
    provider = "Booking";
  }

  return `${provider}|${partnerClickType}|${name}`;
};

function partnerClick(label) {
  return {
    type: "PARTNER_CLICK",
    meta: {
      event: {
        category: "Partner",
        action: "Click",
        label: buildLabel(label),
      },
    },
  };
}

type PageViewName = "infinitescroll.appended" | "poi.rendered";

export function pageView(name: PageViewName) {
  return {
    type: constants.PAGE_VIEW,
    data: { name },
  };
}

export default {
  partnerClick,
};



// WEBPACK FOOTER //
// ./assets/shared/actions/analytics.js